import { format, date, formatTimeSimple } from '../../../common/utils/formatter'
import clsx from 'clsx'

export const shipmentRebookingsColumns = [
  { Header: 'Event Date', accessor: 'creationDateTime', Cell: format(date) },
  { Header: 'Status', accessor: 'status' },
  { Header: 'Type', accessor: 'type' },
  { Header: 'Responsible Party', accessor: 'responsiblePartyCode' },
  { Header: 'Reason', accessor: 'reasonCode' },
  { Header: 'Requestor User', accessor: 'requestorUser' },
  { Header: 'Validator User', accessor: 'validatorUser' },
  { Header: 'Validated', accessor: 'validatedDateTime', Cell: format(date) },
  {
    Header: 'IDP Date',
    accessor: 'iDPPlannedTimestamp',
    Cell: (props) => {
      const {
        iDPPlannedTimestamp: newIDPPlannedTimestamp,
        plannedDeliveryFromTime: newPlannedDeliveryFromTime,
        plannedDeliveryToTime: newPlannedDeliveryToTime,
        originalIdpPlannedTimestamp,
        originalPlannedDeliveryFromTime,
        originalPlannedDeliveryToTime,
      } = props.row.original // this has nothing to do with original IDP, "original" is a property from react-table
      return (
        <div>
          <span
            className={clsx({
              'eds-color--pink-70 fw-bold':
                date(originalIdpPlannedTimestamp) !== date(newIDPPlannedTimestamp),
            })}
          >
            {date(newIDPPlannedTimestamp, { showTime: false })}
          </span>
          <br />
          {newPlannedDeliveryFromTime && newPlannedDeliveryToTime && (
            <span
              className={
                formatTimeSimple(originalPlannedDeliveryFromTime) !== newPlannedDeliveryFromTime ||
                formatTimeSimple(originalPlannedDeliveryToTime) !== newPlannedDeliveryToTime
                  ? 'eds-color--pink-70 fw-bold'
                  : 'eds-color--default'
              }
            >
              {newPlannedDeliveryFromTime} - {newPlannedDeliveryToTime}
            </span>
          )}
        </div>
      )
    },
    minWidth: 150,
    maxWidth: 150,
  },
  { Header: 'Ship To', accessor: 'shipToCode' },
  {
    Header: 'Address Lines',
    accessor: 'addressLine1Text',
    Cell: (props) => {
      const { addressLine1Text, addressLine2Text, addressLine3Text } = props.row.original
      return (
        <div>
          {addressLine1Text} {addressLine2Text} {addressLine3Text}
        </div>
      )
    },
  },
  { Header: 'Zip Code', accessor: 'zipCode' },
  { Header: 'City', accessor: 'cityName' },
  { Header: 'Traffic Instructions', accessor: 'deliveryInstructionText' },
]
